<template>
  <div class="checkAmountBox">
    <!-- 这张图片我直接用了图片的具体宽高  -->
    <img
      style="width: 100%; height: 100%"
      src="@/assets/images/ceyiceTwo.png"
      alt=""
    />
    <div class="lines" ref="lines">
      <h3>恭喜您获得贷款额度</h3>
      <h3 class="money">{{ money || 0 }}万元</h3>
    </div>
    <div class="entry" ref="entry">
      <div class="freeEvaluation apply" @click="apply">申请贷款</div>
      <div class="theEntrance freeEvaluation" @click="freeEvaluation">
        重新评估
      </div>
    </div>
    <calculated-one ref="CalculatedOneRef"></calculated-one>
    <calculated-two ref="CalculatedTwoRef"></calculated-two>
  </div>
</template>
<script>
import { addressIphone, solveIosWeixin } from '@/utils';
import { Toast } from 'vant';
import CalculatedTwo from '../checkAmount/components/CalculatedTwo.vue';
import CalculatedOne from '../checkAmount/components/CalculatedOne.vue';
import bus from '../checkAmount/utils/bus';

export default {
  name: 'loanAmount',
  data() {
    return {
      money: '',
    };
  },
  components: {
    CalculatedTwo,
    CalculatedOne,
  },
  mounted() {
    // 解决ios缓存
    addressIphone();
    // 键盘收起页面布局异常
    solveIosWeixin();
    if (this.$route.query.loanableLines) {
      // eslint-disable-next-line radix
      this.money = parseInt(this.$route.query.loanableLines || 0);
    }
    bus.$on('CalculatedOneEmit', (data) => {
      this.demandName = data.demandName;
      this.demandMoney = data.demandMoney;
      bus.$emit('freeEvaluations', false);
      bus.$emit('changeCalculatedTwoShow', true);
    });
    bus.$on('calculateTwoGetData', (data) => {
      const params = {
        corpName: this.demandName,
        amount: this.demandMoney,
        ...data,
      };
      this.getData(params);
    });

    this.changePosion();
  },
  methods: {
    changePosion() {
      const w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

      const imgHeight = (w * 2668) / 1500;
      this.$refs.lines.style.top = `${imgHeight * 0.46}px`;
      this.$refs.entry.style.top = `${imgHeight * 0.56}px`;
    },

    freeEvaluation() {
      bus.$emit('freeEvaluations', true);
    },
    apply() {
      this.$router.push('/supermarket/v2/');
    },
    getData(params) {
      this.$api.CheckAmount.insertLoanTestInfo(params).then((res) => {
        console.log('res====', res);
        if (res.success) {
          const num = Math.round(Math.random() * 10 + 10);
          let loanableLines;
          if (params.amount < 10) {
            loanableLines = 2;
          } else {
            loanableLines = params.amount * (num / 100);
          }
          if (loanableLines >= 2000) {
            loanableLines = 2000;
          }
          // eslint-disable-next-line radix
          this.money = parseInt(loanableLines || 0);
          bus.$emit('changeCalculatedTwoShow', false);
        } else {
          Toast({
            message: res.returnMessage,
            forbidClick: true, // 背景不可点击
          });
        }
      });
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
}
h3 {
  margin: 0;
}
.freeEvaluation {
  width: 38%;
  height: 37px;
  background: #ff6800;
  border-radius: 36px;
  border-radius: 36px;
  text-align: center;
  line-height: 37px;
  color: #ffffff;
}
.theEntrance {
  background: #fff;
  border: 1px solid #ff6800;
  box-shadow: none;
  margin-left: 17px;
  color: #ff6800;
}
.entry {
  position: absolute;
  top: 56%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  flex-direction: row;
}
.lines {
  width: 100%;
  height: auto;
  text-align: center;
  position: absolute;
  top: 46%;
}
.lines h3:nth-child(1) {
  font-family: PingFangSC-Semibold;
  font-size: 22px;
  color: #ff6601;
}
.lines h3:nth-child(2) {
  font-family: PingFangSC-Semibold;
  font-size: 35px;
  color: #ff6601;
}

.setOf {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
